export default {
	AL: "355",
	DZ: "213",
	AF: "93",
	AR: "54",
	AE: "971",
	AW: "297",
	OM: "968",
	AZ: "994",
	IE: "353",
	EG: "20",
	ET: "251",
	EE: "372",
	AS: "1684",
	AD: "376",
	AO: "244",
	AI: "1264",
	AQ: "672",
	AG: "1268",
	AM: "374",
	AC: "247",
	AU: "61",
	AT: "43",
	BS: "1242",
	BH: "973",
	BD: "880",
	BB: "1246",
	BY: "375",
	BE: "32",
	BZ: "501",
	BJ: "229",
	BM: "1441",
	BT: "975",
	BO: "591",
	BQ: "599",
	BA: "387",
	BW: "267",
	BV: "",
	BR: "55",
	IO: "246",
	BN: "673",
	BG: "359",
	BF: "226",
	BI: "257",
	KH: "855",
	CM: "237",
	CA: "1",
	IC: "",
	CV: "238",
	KY: "1345",
	CF: "236",
	EA: "",
	TD: "235",
	CL: "56",
	CN: "86",
	CX: "61",
	CP: "",
	CC: "61",
	CO: "57",
	KM: "269",
	CK: "682",
	CR: "506",
	CI: "225",
	HR: "385",
	CU: "53",
	CW: "599",
	CY: "357",
	CZ: "420",
	CD: "243",
	DK: "45",
	DG: "",
	DJ: "253",
	DM: "1767",
	DO: "1809",
	TL: "670",
	EC: "593",
	
	SV: "503",
	GQ: "240",
	ER: "291",
	
	EU: "388",
	FK: "500",
	FO: "298",
	FJ: "679",
	FI: "358",
	FR: "33",
	FX: "241",
	// GF: "44",
	PF: "689",
	TF: "",
	GA: "44",
	GM: "220",
	GE: "594",
	DE: "49",
	GH: "233",
	GI: "350",
	GR: "30",
	GL: "299",
	GD: "995",
	// GP: "590",
	GU: "1671",
	GT: "502",
	GG: "",
	GN: "224",
	GW: "245",
	GY: "592",
	HT: "509",
	HM: "",
	HN: "504",
	HK: "852",
	HU: "36",
	IS: "354",
	IN: "91",
	ID: "62",
	IR: "98",
	IQ: "964",
	IM: "44",
	IL: "972",
	IT: "39",
	JM: "1876",
	JP: "81",
	JE: "44",
	JO: "962",
	KZ: "7",
	KE: "254",
	KI: "686",
	KP: "850",
	KR: "82",
	KW: "965",
	KG: "996",
	LA: "856",
	LV: "371",
	LB: "961",
	LS: "266",
	LR: "231",
	LY: "218",
	LI: "423",
	LT: "370",
	LU: "352",
	MO: "853",
	MK: "389",
	MG: "261",
	MW: "265",
	MY: "60",
	MV: "960",
	ML: "223",
	MT: "356",
	MH: "692",
	// MQ: "596",
	MR: "222",
	MU: "230",
	YT: "262",
	MX: "52",
	FM: "691",
	MD: "373",
	MC: "377",
	MN: "976",
	ME: "382",
	MS: "1664",
	MA: "212",
	MZ: "258",
	MM: "95",
	NA: "264",
	NR: "674",
	NP: "977",
	NL: "31",
	NC: "687",
	NZ: "64",
	NI: "505",
	NE: "227",
	NG: "234",
	NU: "683",
	// NF: "672",
	MP: "1670",
	NO: "47",
	
	PK: "92",
	PW: "680",
	PS: "970",
	PA: "507",
	PG: "675",
	PY: "595",
	PE: "51",
	PH: "63",
	PN: "",
	PL: "48",
	PT: "351",
	PR: "1787",
	QA: "974",
	CG: "242",
	RE: "262",
	RO: "40",
	RU: "7",
	RW: "250",
	BL: "590",
	SH: "290",
	KN: "1869",
	LC: "1758",
	MF: "590",
	PM: "508",
	VC: "1784",
	WS: "685",
	SM: "378",
	ST: "239",
	SA: "966",
	SN: "221",
	RS: "381",
	SC: "248",
	SL: "232",
	SG: "65",
	SX: "1721",
	SK: "421",
	SI: "386",
	SB: "677",
	SO: "252",
	ZA: "27",
	GS: "",
	ES: "34",
	LK: "94",
	SD: "249",
	SR: "597",
	SJ: "47",
	SZ: "268",
	SE: "46",
	CH: "41",
	SY: "963",
	TW: "886",
	TJ: "992",
	TZ: "255",
	TH: "66",
	TG: "228",
	TK: "690",
	TO: "676",
	TT: "1868",
	TA: "290",
	TN: "216",
	TR: "90",
	TM: "993",
	TC: "1649",
	TV: "688",
	SU: "",
	UG: "256",
	UA: "380",
	GB: "44",
	UK: "",
	US: "1",
	UM: "",
	UY: "598",
	UZ: "998",
	VU: "678",
	VA: "379",
	VE: "58",
	VN: "84",
	VG: "1284",
	VI: "1340",
	WF: "681",
	EH: "212",
	YE: "967",
	ZM: "260",
	ZW: "263"
};



// WEBPACK FOOTER //
// ./js/component/select-country/countryCode.js